import Config from '../../Config'
import { push } from 'connected-react-router'
import { TOKEN_KEY } from '../../auth/Auth'
import { AccountLoginErrorCodes, hexStringFromErrorCode } from '../../util/ErrorCodes'

// Log into the system
export const LOGOUT_REQUESTED = 'LOGOUT_REQUESTED'

export const requestLogout = (username, password) => {
  return {
    type: LOGOUT_REQUESTED
  }
}

export const LOGOUT_FAILED = 'LOGOUT_FAILED'

export const failLogout = (errorMessage) => {
  return {
    type: LOGOUT_FAILED,
    errorMessage
  }
}

export const LOGOUT_SUCCESSFUL = 'LOGOUT_SUCCESSFUL'

export const successfulLogout = (user, msg) => {
  return {
    type: LOGOUT_SUCCESSFUL,
    user: user,
    msg
  }
}

export const REDIRECT_TO_ERRORPAGE = 'REDIRECT_TO_ERRORPAGE'

export const redirectToErrorPage = () => {
  return {
    type: REDIRECT_TO_ERRORPAGE
  }
}

export const RESET_MSG = 'RESET_MSG'

export const resetMessage = () => {
  return {
    type: RESET_MSG
  }
}

export const logout = (msg) => {
  return function (dispatch) {
    dispatch(requestLogout())
    let token = window.localStorage.getItem(TOKEN_KEY)
    return window.fetch(Config.apiUrl + '/Account/Logout', {
      method: 'get',
      headers: {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        const isBannerViewed = window.localStorage.getItem('isBannerViewed')
        window.localStorage.clear()
        // We are clearing local storage and setting the item again to prevent the new features
        // modal dialog from popping up again if already viewed.
        if (isBannerViewed) {
          window.localStorage.setItem('isBannerViewed', isBannerViewed)
        }
        // basically only dispatch if we are not on the server error page. This is realted to card #3928
        if (window.location.pathname.toLowerCase().indexOf('servererror') < 0) {
          dispatch(successfulLogout(response, msg))

          const multipleAccessErrorCode = hexStringFromErrorCode(AccountLoginErrorCodes.MULTIPLE_ACCESS)
          const legacyErrorCode = hexStringFromErrorCode(AccountLoginErrorCodes.UNKNOWN_LEGACY_ERROR_BLAME_MARK)

          if (msg && (msg.friendlyCode.indexOf(multipleAccessErrorCode) >= 0 || msg.friendlyCode.indexOf(legacyErrorCode) >= 0)) {
            dispatch(redirectToErrorPage())
            dispatch(push('/servererror'))
          } else {
            // We don't dispatch the push anymore as we need the app to be reloaded.
            // dispatch(push('/'))
            window.location = '/'
          }
        }
      }
      )
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/logoutActions.js